<template>
  <div v-if="offers.length > 0">
    <EnrollmentCard
      v-for="(enrollment, index) in offers"
      @change:status="updateEnrollmentStatus(enrollment, $event)"
      :key="'offer' + enrollment.id"
      :class="cardClass(index, offers.length)"
      :data-testid="`enrollment-card-${enrollment.id}`"
      :enrollment="enrollment"
      :index="index"
      :ordered="subsidyProgram.allow_preference_order"
      :processing="processing"
      :removable="false"
      :reorderable="false"
      :show-action-menu="false"
      :subsidy-program="subsidyProgram"
      outlined
    />
  </div>
</template>

<script setup>
import EnrollmentCard from '@/parent/components/EnrollmentCard.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';
import { ENROLLMENT_STATUSES } from '@/shared/assets/constants';

const { api } = useApi();
const eventBus = useEventBus();
const emit = defineEmits(['changed']);

const processing = defineModel('processing', {
  type: Boolean,
  default: false,
});

const props = defineProps({
  childData: {
    type: Object,
    required: true,
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
});

defineExpose({ loadOffers });

const offers = ref([]);

function cardClass(index, length) {
  return {
    'mb-4': length > 1 && index < length - 1,
  };
}

async function loadOffers() {
  const resp = await api.parent.enrollment.index({ child_id: props.childData.id });

  if (resp?.data) {
    const enrollments = resp.data;

    const filteredEnrollments = enrollments.filter((enrollment) => {
      return (
        (enrollment.public_status === ENROLLMENT_STATUSES.OFFERED ||
          enrollment.public_status === ENROLLMENT_STATUSES.ACCEPTED) &&
        enrollment.subsidy_program_id === props.subsidyProgram.id
      );
    });

    offers.value = filteredEnrollments.sort((a, b) => a.preference_order - b.preference_order);
  }
}

async function updateEnrollmentStatus(enrollment, newVal) {
  processing.value = true;
  await api.parent.enrollment_status
    .update(enrollment.id, newVal)
    .catch((error) => eventBus.error(error));

  await loadOffers();
  emit('changed');
  processing.value = false;
}

onMounted(loadOffers);
</script>
